import ugcApi from "@apis/ugc.api";
import type { UgcContextParams } from "@apis/ugc.api";

interface SeReferenceResponse {
  se_text?: unknown;
}

export async function getSeReferenceText(params: UgcContextParams): Promise<string> {
  if (!params.uuid) {
    return "";
  }

  const signedUrlResponse = await ugcApi.getSeReferenceUrl(params);
  if (signedUrlResponse.code !== "ok") {
    throw new Error("Failed to get SE reference URL");
  }
  if (!signedUrlResponse.data) {
    return "";
  }

  // the folder wildcard signing policy permits cache busting query params
  const referenceUrl = new URL(signedUrlResponse.data);
  referenceUrl.searchParams.set("t", String(Date.now()));

  // the file is never written when SE grading fails (the error banner already covers it), and S3/CloudFront
  // then answers 403 without CORS headers, which surfaces as a fetch rejection
  const signedContentResponse = await fetch(referenceUrl.toString(), {
    credentials: "omit",
    cache: "no-store",
  }).catch(() => null);
  if (!signedContentResponse?.ok) {
    return "";
  }

  const responseJson = (await signedContentResponse.json()) as SeReferenceResponse;
  return typeof responseJson.se_text === "string" ? responseJson.se_text : "";
}
